var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phone-scan" }, [
      _c("div", { staticClass: "qr-image", attrs: { id: "browseInPhone" } }, [
        _c("div", { staticClass: "sohu-logo" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text1" }, [
        _c("span", [_vm._v("扫码打开")]),
        _vm._v(" "),
        _c("span", { staticClass: "border-font" }, [_vm._v("手机搜狐网")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text2" }, [
        _c("div", [_vm._v("无需下载APP")]),
        _vm._v(" "),
        _c("div", [_vm._v("精彩内容随时看")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }